<template>
  <div id="app">
      <router-view style="flex-grow: 1; height: 100%;"/>
  </div>
</template>

<script>
import { L10n, setCulture } from '@syncfusion/ej2-base';

  export default {
    name: 'app',
    components: {
    },
    methods: {
      setGridCulture() {
        setCulture(this.$root.$i18n.t('ej2LocaleCulture'));
        L10n.load({
          'en-US': {
            'grid': {
                'EmptyRecord': this.$root.$i18n.t('emptyRecord'),
                'Item': this.$root.$i18n.t('item'),
                'Items': this.$root.$i18n.t('items'),
                'Search':this.$root.$i18n.t('search'),
                "Pdfexport":this.$root.$i18n.t('Pdfexport'),
                "Excelexport":this.$root.$i18n.t('Excelexport'),
                "Csvexport":this.$root.$i18n.t('Csvexport'),
                "FilterButton":this.$root.$i18n.t('FilterButton'),
                "ClearButton":this.$root.$i18n.t('ClearButton'),
                "StartsWith":this.$root.$i18n.t('StartsWith'),
                "EndsWith":this.$root.$i18n.t('EndsWith'),
                "Contains":this.$root.$i18n.t('Contains'),
                "Equal":this.$root.$i18n.t('Equal'),
                "NotEqual":this.$root.$i18n.t('NotEqual'),
                "LessThan":this.$root.$i18n.t('LessThan'),
                "LessThanOrEqual":this.$root.$i18n.t('LessThanOrEqual'),
                "GreaterThan":this.$root.$i18n.t('GreaterThan'),
                "GreaterThanOrEqual":this.$root.$i18n.t('GreaterThanOrEqual'),
                "ChooseDate":this.$root.$i18n.t('ChooseDate'),
                "EnterValue":this.$root.$i18n.t('EnterValue'),
                "NoResult":this.$root.$i18n.t('NoResult'),
                "ClearFilter":this.$root.$i18n.t('ClearFilter'),
                "ChooseColumns": this.$root.$i18n.t('ChooseColumns'),
                "SelectAll": this.$root.$i18n.t('SelectAll'),
                "Columnchooser": this.$root.$i18n.t('Columnchooser'),
                "OKButton": this.$root.$i18n.t('OKButton'),
                "CancelButton": this.$root.$i18n.t('CancelButton')
            },
            'pager':{
                'pagerDropDown':this.$root.$i18n.t('pagerDropDown'),
                'currentPageInfo': this.$root.$i18n.t('currentPageInfo'),
                'totalItemsInfo': this.$root.$i18n.t('totalItemsInfo'),
                'totalItemInfo': this.$root.$i18n.t('totalItemInfo')
            }
          },
          "pl-PL": {
            'grid': {
                'EmptyRecord': this.$root.$i18n.t('emptyRecord'),
                'Item': this.$root.$i18n.t('item'),
                'Items': this.$root.$i18n.t('items'),
                'Search':this.$root.$i18n.t('search'),
                "Pdfexport":this.$root.$i18n.t('Pdfexport'),
                "Excelexport":this.$root.$i18n.t('Excelexport'),
                "Csvexport":this.$root.$i18n.t('Csvexport'),
                "FilterButton":this.$root.$i18n.t('FilterButton'),
                "ClearButton":this.$root.$i18n.t('ClearButton'),
                "StartsWith":this.$root.$i18n.t('StartsWith'),
                "EndsWith":this.$root.$i18n.t('EndsWith'),
                "Contains":this.$root.$i18n.t('Contains'),
                "Equal":this.$root.$i18n.t('Equal'),
                "NotEqual":this.$root.$i18n.t('NotEqual'),
                "LessThan":this.$root.$i18n.t('LessThan'),
                "LessThanOrEqual":this.$root.$i18n.t('LessThanOrEqual'),
                "GreaterThan":this.$root.$i18n.t('GreaterThan'),
                "GreaterThanOrEqual":this.$root.$i18n.t('GreaterThanOrEqual'),
                "ChooseDate":this.$root.$i18n.t('ChooseDate'),
                "EnterValue":this.$root.$i18n.t('EnterValue'),
                "NoResult":this.$root.$i18n.t('NoResult'),
                "ClearFilter":this.$root.$i18n.t('ClearFilter'),
                "ChooseColumns": this.$root.$i18n.t('ChooseColumns'),
                "SelectAll": this.$root.$i18n.t('SelectAll'),
                "Columnchooser": this.$root.$i18n.t('Columnchooser'),
                "OKButton": this.$root.$i18n.t('OKButton'),
                "CancelButton": this.$root.$i18n.t('CancelButton')
            },
            'pager':{
                'pagerDropDown':this.$root.$i18n.t('pagerDropDown'),
                'currentPageInfo': this.$root.$i18n.t('currentPageInfo'),
                'totalItemsInfo': this.$root.$i18n.t('totalItemsInfo'),
                'totalItemInfo': this.$root.$i18n.t('totalItemInfo')
            }
          },
          "no-NL": {
            "grid": {
                'EmptyRecord': this.$root.$i18n.t('emptyRecord'),
                'Item': this.$root.$i18n.t('item'),
                'Items': this.$root.$i18n.t('items'),
                'Search':this.$root.$i18n.t('search'),
                "Pdfexport":this.$root.$i18n.t('Pdfexport'),
                "Excelexport":this.$root.$i18n.t('Excelexport'),
                "Csvexport":this.$root.$i18n.t('Csvexport'),
                "FilterButton":this.$root.$i18n.t('FilterButton'),
                "ClearButton":this.$root.$i18n.t('ClearButton'),
                "StartsWith":this.$root.$i18n.t('StartsWith'),
                "EndsWith":this.$root.$i18n.t('EndsWith'),
                "Contains":this.$root.$i18n.t('Contains'),
                "Equal":this.$root.$i18n.t('Equal'),
                "NotEqual":this.$root.$i18n.t('NotEqual'),
                "LessThan":this.$root.$i18n.t('LessThan'),
                "LessThanOrEqual":this.$root.$i18n.t('LessThanOrEqual'),
                "GreaterThan":this.$root.$i18n.t('GreaterThan'),
                "GreaterThanOrEqual":this.$root.$i18n.t('GreaterThanOrEqual'),
                "ChooseDate":this.$root.$i18n.t('ChooseDate'),
                "EnterValue":this.$root.$i18n.t('EnterValue'),
                "NoResult":this.$root.$i18n.t('NoResult'),
                "ClearFilter":this.$root.$i18n.t('ClearFilter'),
                "ChooseColumns": this.$root.$i18n.t('ChooseColumns'),
                "SelectAll": this.$root.$i18n.t('SelectAll'),
                "ChooseColumns": this.$root.$i18n.t('ChooseColumns'),
                "SelectAll": this.$root.$i18n.t('SelectAll'),
                "Columnchooser": this.$root.$i18n.t('Columnchooser'),
                "OKButton": this.$root.$i18n.t('OKButton'),
                "CancelButton": this.$root.$i18n.t('CancelButton')
            },
            'pager':{
                'pagerDropDown':this.$root.$i18n.t('pagerDropDown'),
                'currentPageInfo': this.$root.$i18n.t('currentPageInfo'),
                'totalItemsInfo': this.$root.$i18n.t('totalItemsInfo'),
                'totalItemInfo': this.$root.$i18n.t('totalItemInfo')
            }
          }
        });
      }
    },
    async mounted() {
      this.$store.dispatch('set_isMobile', /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))

      this.$root.$i18n.locale = this.$store.getters.language
      this.setGridCulture();
    }
  }
</script>

<style>
@import url('~@/assets/css/bootstrap.css');
@import url('~@/assets/css/style.css');
@import url('~@/assets/css/main-submenu.css');
@import url('~@/assets/css/sidebar-menu.css');
@import url('~@/assets/css/snackbar.css');

@import url('../node_modules/@syncfusion/ej2-base/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-buttons/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-calendars/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-dropdowns/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-inputs/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-navigations/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-popups/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css');
@import url('../node_modules/@syncfusion/ej2-vue-grids/styles/material.css');

@import url('~@/assets/css/syncfusiongrid.css');
/* Ostatni, żeby nakładka trybu ciemnego nadpisywała style paczek powyżej. */
@import url('~@/assets/css/theme.css');
#app {
  height: 100%;
  display: flex;
  flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/App.vue